import React, { useMemo } from "react";
import { Button, Result, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const AccessDenied = ({
  title = "Sem acesso",
  subTitle = "Você não tem permissão para acessar este módulo.",
  showBack = true,
  showHome = true,
  homeTo,
  backLabel = "Voltar",
  homeLabel = "Ir para início",
  padding = 24,
  extra,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const resolvedHomeTo = useMemo(() => {
    if (homeTo) return homeTo;
    return location.state?.from || "/";
  }, [homeTo, location.state?.from]);

  const resolvedExtra = useMemo(() => {
    if (extra) return extra;
    if (!showBack && !showHome) return null;

    return (
      <Space>
        {showBack ? (
          <Button onClick={() => navigate(-1)}>{backLabel}</Button>
        ) : null}
        {showHome ? (
          <Button
            type="primary"
            onClick={() => navigate(resolvedHomeTo, { replace: true })}
          >
            {homeLabel}
          </Button>
        ) : null}
      </Space>
    );
  }, [
    backLabel,
    extra,
    homeLabel,
    navigate,
    resolvedHomeTo,
    showBack,
    showHome,
  ]);

  return (
    <div style={{ padding }}>
      <Result status="403" title={title} subTitle={subTitle} extra={resolvedExtra} />
    </div>
  );
};

export default AccessDenied;

